import URL from '../helper';
import { saveByteArray } from '../javascript';
import axiosCall from './interceptor';

export const getInteractiveDesign = async templateId => {
  const url = `${URL.DESIGN_SYSTEM_URL}interactiveDesign/${templateId}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const updateInteractiveDesign = async (templateId, payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}interactiveDesign/${templateId}`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const getAllInteractiveDesigns = async (payload) => {
  const params = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}fetchInteractiveDesign?${params.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const generateInteractiveDoc = async (payload, documentId) => {
  const url =`${URL.TRANSACTION_SYSTEM_URL}print/interactiveDesign/${documentId}`;
  payload.documentDTO.documentId = undefined;
  let response = await axiosCall('post', url, payload, true, false, false);
  return response;
  
}

export const getPublishBlockByCategory = async (payload) => {
    const params = new URLSearchParams(payload);
    const url = `${URL.TRANSACTION_SYSTEM_URL}publishBlockByCategory?${params.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const fetchPublishedBlock  = async (payload) => { 
  const url = `${URL.TRANSACTION_SYSTEM_URL}publishedBlock`;
  let response = await axiosCall('get', url, payload);
  return response.data;
}
